"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var _kernel_container_1 = __importDefault(require("../../../container"));
var generation_1 = require("../../stores/generation");
var Generation_1 = __importDefault(require("../../services/Generation"));
var checkRequiredPlayState_1 = __importDefault(require("../playback/checkRequiredPlayState"));
var playlist_1 = require("../../selectors/playlist");
var player_1 = require("../../selectors/player");
var generation_2 = require("../../selectors/generation");
var history_1 = require("../../selectors/history");
var mediafiles_1 = require("../../selectors/mediafiles");
var addGenerationRotations_1 = __importDefault(require("./addGenerationRotations"));
var reactions_1 = require("../../selectors/reactions");
function regeneratePlaylist(switchImmediately, onRegenerated) {
    var _this = this;
    var action = function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var logger, settings, playlistLengthLimit, minPlaylistLength, regenerationInProgress, _a, inSafeZone, nextTime, availableMediafileIds, mediafiles, generationSettings, history, nextShouldSwitch, dislikes, playlist, pattern, cutDuration, generationType, startTrack, rotations, afterTrack, e_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    logger = _kernel_container_1.default.get("LOGGING").getLogger("@kernel/regeneratePlaylist");
                    settings = _kernel_container_1.default.get("SETTINGS");
                    playlistLengthLimit = settings.getSetting("LIMIT_MEDIAFILES_IN_PLAYLIST", 50);
                    minPlaylistLength = settings.getSetting("REGENERATE_MIN_PLAYLIST_LENGTH", 20);
                    regenerationInProgress = (0, generation_2.selectIsRegenerationInProgress)(getState());
                    if (regenerationInProgress) {
                        logger.debug("Regeneration already in progress, skipping regeneration..");
                        return [2];
                    }
                    _a = selector(getState()), inSafeZone = _a.inSafeZone, nextTime = _a.nextTime, availableMediafileIds = _a.availableMediafileIds, mediafiles = _a.mediafiles, generationSettings = _a.generationSettings, history = _a.history, nextShouldSwitch = _a.nextShouldSwitch, dislikes = _a.dislikes, playlist = _a.playlist, pattern = _a.pattern, cutDuration = _a.cutDuration;
                    if (!inSafeZone) {
                        logger.warn("Skipping regeneration, not in safe zone");
                        dispatch((0, generation_1.markRegenerationRequired)(true, switchImmediately !== null && switchImmediately !== void 0 ? switchImmediately : false));
                        return [2];
                    }
                    if (!generationSettings) {
                        logger.warn("No generation settings present, skipping...");
                        return [2];
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    dispatch((0, generation_1.setGenerationMetadata)({
                        regenerationInProgress: true,
                    }));
                    generationType = "correction";
                    if (!playlist.length) {
                        generationType = "initial";
                    }
                    else if (playlist.length < minPlaylistLength) {
                        generationType = "sizeLimit";
                    }
                    startTrack = (0, playlist_1.selectCurrentPlaylistItem)(getState());
                    logger.info("Regenerating playlist");
                    return [4, Generation_1.default.generateRotations(__assign(__assign(__assign(__assign({}, generationSettings), (typeof pattern === "string" && { pattern: pattern })), (typeof cutDuration === "number" && { cutDuration: cutDuration })), { history: history, numberMediafiles: playlistLengthLimit, startTime: nextTime, dislikedMediafiles: dislikes }), mediafiles, availableMediafileIds, generationType)];
                case 2:
                    rotations = _b.sent();
                    afterTrack = (0, playlist_1.selectCurrentPlaylistItem)(getState());
                    if ((startTrack === null || startTrack === void 0 ? void 0 : startTrack.rotationId) !== (afterTrack === null || afterTrack === void 0 ? void 0 : afterTrack.rotationId)) {
                        logger.warn("Current rotation changed while performing regeneration, running regeneration", {
                            startTrack: startTrack,
                            afterTrack: afterTrack,
                        });
                        dispatch((0, generation_1.markRegenerationRequired)(true, switchImmediately !== null && switchImmediately !== void 0 ? switchImmediately : false));
                    }
                    else {
                        dispatch((0, addGenerationRotations_1.default)(rotations, switchImmediately !== null && switchImmediately !== void 0 ? switchImmediately : nextShouldSwitch));
                        dispatch((0, generation_1.markRegenerationRequired)(false, false));
                        onRegenerated === null || onRegenerated === void 0 ? void 0 : onRegenerated();
                    }
                    return [3, 5];
                case 3:
                    e_1 = _b.sent();
                    logger.error("Got error while trying to perform regeneration", {
                        err: e_1.toString(),
                    });
                    return [3, 5];
                case 4:
                    dispatch((0, generation_1.setGenerationMetadata)({
                        regenerationInProgress: false,
                    }));
                    return [7];
                case 5:
                    dispatch((0, checkRequiredPlayState_1.default)());
                    return [2];
            }
        });
    }); };
    action.type = "regeneratePlaylist";
    return action;
}
exports.default = regeneratePlaylist;
function selector(state) {
    var onlyOfflineMode = _kernel_container_1.default.get("SETTINGS").getSetting("PLAYER_ONLY_OFFLINE_MODE", false);
    var generationPattern = _kernel_container_1.default.get("SETTINGS").getSetting("GENERATION_PATTERN");
    var cutDuration = _kernel_container_1.default.get("SETTINGS").getSetting("CUT_DURATION");
    var history = (0, history_1.selectHistoryItems)(state);
    var currentStreamId = (0, generation_2.selectCurrentStreamId)(state);
    return {
        inSafeZone: (0, playlist_1.selectSafeSwitchZone)(state),
        generationSettings: (0, generation_2.selectCurrentGenerationSettings)(state),
        availableMediafileIds: (0, playlist_1.selectCurrentAvailableMediafileIds)(state, onlyOfflineMode),
        playlist: (0, playlist_1.selectPlaylistItems)(state),
        nextTime: (0, player_1.selectNextTrackWillStart)(state),
        mediafiles: (0, mediafiles_1.selectMediafiles)(state),
        nextShouldSwitch: (0, generation_2.selectNextRegenerationShouldImmediatelySwitch)(state),
        history: history,
        dislikes: currentStreamId ? (0, reactions_1.selectDislikedTracks)(state, currentStreamId) : [],
        pattern: generationPattern,
        cutDuration: cutDuration,
    };
}
//# sourceMappingURL=regeneratePlaylist.js.map